const routes = [
    {
        path: "/lecturer/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "section_instructorlecturereportexcelexport"
        }
    }
];

export default routes;
